<template>
  <div class="air-calendar-year__container w100 flex jbetween wrap">
    <month-calendar
      v-for="month in 12"
      :key="`month-${month}`"
      :month="month"
      v-bind="$attrs"
      v-on="$listeners"
    >
    </month-calendar>
  </div>
</template>

<script>
import MonthCalendar from './MonthCalendar'

export default {
  name: 'YearCalendar',
  components: { MonthCalendar },
  props: {
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.air-calendar-year__container {
}
</style>
